import Filters from "./components/Filters";
import Preview from "./components/Preview";
import BatchApproveAllowanceContextProvider from "./contexts";

function BatchApproveAllowance() {
  return (
    <BatchApproveAllowanceContextProvider>
      <Filters />
      <br />
      <Preview />
    </BatchApproveAllowanceContextProvider>
  );
}

export default BatchApproveAllowance;
